import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/legal")({
  component: Legal
});

function Legal() {
  return (
    <div className="from-background-gradient via-background to-background text-tx-primary scroll-primary flex h-screen w-screen flex-col overflow-auto bg-gradient-to-b p-8 antialiased">
      <h1 className="text-tx-primary mb-4 text-3xl font-bold">Legal Notices</h1>
      <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">Last updated: November 11, 2024</h2>
      <p className="mb-6">
        These Legal Notices apply to all products, services, and websites owned, operated, or maintained by Moe Capital
        LLC, including anime.gf and anime.bf. By accessing or using any of our services or platforms, you acknowledge
        that you have read, understood, and agree to be bound by these notices, including any applicable terms of
        service, privacy policies, and compliance with relevant laws. These notices are intended to govern the rights
        and obligations of Moe Capital LLC and all users, including visitors, customers, and other authorized
        individuals, collectively referred to as "you."
      </p>

      <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">1. 18 U.S.C. § 2257 Exemption Statement</h2>
      <h3 className="text-tx-secondary mb-4 text-xl font-semibold">
        1.1 Applicability to Moe Capital LLC and Associated Websites
      </h3>
      <p className="mb-6">
        Pursuant to <strong>18 U.S.C. § 2257</strong> and related regulations, Moe Capital LLC and its associated
        websites, including anime.gf and anime.bf, are not subject to the record-keeping requirements outlined in this
        section because:
      </p>
      <ul className="mb-6 list-inside list-disc">
        <li>The websites do not contain any depictions of actual human beings engaged in sexually explicit conduct.</li>
        <li>
          All visual content on these websites consists exclusively of artificial creations generated by Artificial
          Intelligence (AI) technology.
        </li>
        <li>
          No human models, actors, actresses, or real persons are featured in any capacity within the AI-generated
          imagery on these websites.
        </li>
      </ul>
      <h3 className="text-tx-secondary mb-4 text-xl font-semibold">1.2 Content Produced by Third Parties</h3>
      <p className="mb-6">
        For visual depictions that may be submitted by third-party users or members, Moe Capital LLC operates solely as
        a service provider. The company's activities are limited to the transmission, storage, retrieval, hosting,
        and/or formatting of content posted by users. Moe Capital LLC does not act as the primary producer of any such
        depictions.
      </p>
      <p className="mb-6">
        In accordance with <strong>18 U.S.C. § 2257 (h) (2) (B) (v)</strong> and <strong>47 U.S.C. § 230 (c)</strong>,
        Moe Capital LLC reserves the right (but not the obligation) to remove content posted by users that it deems
        inconsistent with its policies or terms of service, including content that is indecent, obscene, defamatory, or
        otherwise objectionable.
      </p>
      <h2 className="text-tx-secondary mb-4 text-2xl font-semibold">2. Contact Us</h2>
      <p className="mb-6">
        If you have any questions about our Terms of Services, Privacy Policy, or Legal Notices, please contact us at{" "}
        <a href="mailto:hey@anime.gf" className="text-blue-500 hover:underline">
          hey@anime.gf
        </a>
        .
      </p>
    </div>
  );
}
